import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';

import { DatePicker } from 'material-ui-pickers';

import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const styles = theme => ({
  root: {
    marginTop: theme.spacing.unit*2,
  },
  avatar: {
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: theme.spacing.unit*2,
  },
  left: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  smallField: {
    maxWidth: '100px',
  },
  children: {
    minWidth: '300px',
  },
  marginBottom: {
    marginBottom: theme.spacing.unit*2,
  },
});


//TODO: replace with GRID layout rather than cssinjs
const Detail = ({ classes, receipt, vendors, children, handleChange }) => {

  return(
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="Recipe" className={classes.avatar}>
            R
          </Avatar>
        }
        title="Receipt"
      />
      <CardContent>
        <div className={classes.row}>
          <div className={classes.left}>
            <div className={classes.column}>
              <DatePicker
                  className={classes.marginBottom}
                  label="Date"
                  format="MMMM Do YYYY"
                  value={new Date()}
                  leftArrowIcon={<ArrowBackIcon />}
                  rightArrowIcon={<ArrowForwardIcon />}
                  onChange={(date) => handleChange("date", date.toDate().getTime())}
                />

              <FormControl
                style={{margin: '0px'}}
                className={classNames(classes.formControl, classes.marginBottom)}>
                <InputLabel htmlFor="vendor-simple">Vendor</InputLabel>
                <Select
                  value={receipt.vendorId === undefined ? "" : receipt.vendorId}
                  onChange={(event) => {
                    handleChange("vendorId", event.target.value);
                  }}
                  inputProps={{
                    name: 'vendorId',
                    id: 'vendor-simple',
                  }}
                >
                  {vendors &&
                    vendors.map((vendor, i) => {
                      return <MenuItem key={i} value={vendor.id}>{vendor.name}</MenuItem>
                    })
                  }
                </Select>
              </FormControl>
            </div>
            <div className={classes.column}>
              <TextField
                className={classNames(classes.smallField, classes.marginBottom)}
                label="Tax"
                margin="none"
                value={receipt.tax}
                onChange={(event) => handleChange("tax", event.target.value)}
              />
              <TextField
                className={classNames(classes.smallField, classes.marginBottom)}
                label="Total"
                margin="none"
                value={receipt.total}
                onChange={(event) => handleChange("total", event.target.value)}
              />
            </div>
          </div>
          <div className={classes.children}>
            {children}
          </div>
        </div>
        <div>
          <TextField
            margin="dense"
            id="name"
            label="Notes (optional)"
            fullWidth
            multiline={true}
            value={receipt.notes}
            onChange={(event) => handleChange("notes", event.target.value)}
          />
        </div>
      </CardContent>
    </Card>
  );
};



const mapStateToProps = (state) => {
  const vendors = state.vendorsState;
  return {
    vendors: vendors,
  }
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(Detail);



// WEBPACK FOOTER //
// ./src/components/admin/Receipts/Dialog/Detail.jsx